export default "__VITE_ASSET__DIwuyXPz__"